import {
    Box,
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerOverlay,
    IconButton,
    VStack,
    Text,
    useDisclosure,
    Flex,
    Image,
} from '@chakra-ui/react';
import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import AnimatedLink from '../NavBar/AnimatedLink/AnimatedLink';

interface SidebarMenuProps {
    active: string;
    menuItems: { label: string; href: string }[];
    onNavigate?: (id: string) => void;
}

const SidebarMenu: FC<SidebarMenuProps> = ({ active, menuItems, onNavigate }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const handleClick = (href: string) => {
        onNavigate?.(href);
        onClose();
    };

    return (
        <>
            <Flex
                display={{ base: 'flex', md: 'none' }}
                alignItems="center"
                justifyContent="space-between"
                bg="white"
                px={4}
                py={3}
                width="100%"
                height="80px"
                boxShadow="md"
                position="fixed"
                top={0}
                left={0}
                zIndex={999}
            >
                <IconButton
                    icon={<FontAwesomeIcon icon={faBars} />}
                    onClick={onOpen}
                    variant="ghost"
                    aria-label="Abrir menu"
                    color="color.500"
                    fontSize="2xl"
                    zIndex={2}
                />

                <Box
                    position="absolute"
                    left="50%"
                    transform="translateX(-50%)"
                    pointerEvents="none"
                >
                    {/* <Text
                        fontSize="xl"
                        fontWeight="bold"
                        color="color.500"
                        textTransform="uppercase"
                        userSelect="none"
                    >
                        DONNA CEGONHA
                    </Text> */}
                    <Image
                        src={require("../../assets/img/logo-donna-cegonha.png")}
                        alt="Logo Donna Cegonha"
                        objectFit="contain"
                        w="60px"
                        h="60px"
                    />
                </Box>
            </Flex>

            <Drawer placement="left" onClose={onClose} isOpen={isOpen} size="xs">
                <DrawerOverlay />
                <DrawerContent bg="white">
                    <DrawerBody mt={10}>
                        <VStack spacing={6} align="flex-start">
                            {menuItems.map(({ label, href }) => (
                                <Box
                                    key={label}
                                    cursor="pointer"
                                    onClick={() => handleClick(href)}
                                >
                                    <AnimatedLink
                                        to={href}
                                        isActive={active === href}
                                    >
                                        {label}
                                    </AnimatedLink>
                                </Box>
                            ))}
                        </VStack>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    );
};

export default SidebarMenu;
